import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../../../lib/api';
import { useNotification } from '../../../../shared/Notification/useNotification';

const mutationFn = ({ campaignId, dates }) => {
  const [startDate, endDate] = dates;

  return api.patch(`/api/client_admin/campaigns/${campaignId}`, {
    campaign: {
      start_date: startDate,
      end_date: endDate,
    },
  });
};

export const useCampaignDateUpdate = () => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation('campaigns');

  const { mutate, isLoading } = useMutation({
    mutationFn,
    onSuccess: () => {
      showSuccess({ content: t('dateUpdate.success') });

      queryClient.invalidateQueries(['campaigns-by-year']);
    },
  });

  const updateCampaignDates = (campaignId, dates) => {
    mutate({ campaignId, dates });
  };

  return {
    updateCampaignDates,
    isLoading,
  };
};
